module.exports = __webpack_public_path__ + "img/left-arrow.e676f1f3.svg";